import { combineEpics } from 'redux-observable';
import {
    pushUpcomingApptsEpic,
    clearUpcomingApptEpic,
    skeletonUpcomingApptsReset
} from './upcomingappointments/src/index';
import {
    fetchApptsEpic,
    pushApptsTableEpic,
    pushCancelApptToEpic,
    pushConfirmApptToEpic,
    pushUpdateApptToEpic,
    clearAppointmentsEpic,
    clearAppointmentsonPatientChangeEpic
} from './appointments/src/index';
import {
    fetchDashboardApi
} from './dashboard/src/index';
import {
    pushPendingBillsToState,
    clearPendingBillsEpic
} from './pendingbills/src/index';
import {
    fetchCallingDest,
    clearCalledDestination
} from './calleddest/src/index';
import {
    fetchPharmacyEpic,
    clearPharmacyEpic
} from './pharmacies/src/index';
import {
    fetchCallerDetailsFromDB, pushPatientDataToCaller,
    pushSelectedPatientDataToCaller, fetchSouceTypeToCaller,
    fetchSelectedSouceTypeToCaller, clearSourceEpic,
    clearSourceTypeEpic, setSourceAsItIsSubject
} from './source/src/index';
import {
    fetchPatientsEpic,
    selectDrawer,
    healthAlert,
    fetchConsolidatedAPIOneEpic,
} from './subject/src/index';
import {
    fetchPendingRefEpic,
    clearPendingRefEpic
} from './pendingreferrals/src/index';
import {
    fetchPCPEpic,
    clearPCPEpic,
    clearErrorEpic
} from './pcp/src/index';
import { fetchScreenpopEpic } from './screenpop/src/index';
import { fetchReceiveCommunicationEpic } from './receivecommunication/src/index';
import {
    setCallerDetailsFromAddNew,
    pushAddNewDataToCaller,
    checkForAddNewNotification,
    pushAddNewSelectedSouceTypeToCaller,
    pushAddNewSelectedPatientDataToCaller,
} from './addnew/src/index';

import {
    fetchAllergiesEpic, clearAllergiesEpic
} from './activeallergies/src/index';

import {
    fetchActiveProblemEpic, clearActiveProblemEpic
} from './activeproblems/src/index';

import {
    fetchMedicalHistoryEpic, clearMedicalHistoryEpic
} from './medicalhistory/src/index';

import {
    fetchPatientsGlobalSearchEpic,
    resetSpinForPateintGlobalSearchEpic,
} from './patientglobalsearch/src/index';

import {
    fetchProvidersGlobalSearchEpic,
    resetSpinForProviderGlobalSearchEpic,
} from './providerglobalsearch/src/index';

import {
    pushCallRecord,
} from './pushcallrecord/src/index';

import {
    storeDispositionCode
} from './dispositionstore/src/index';

import {
    clearSkeletonEpic,
} from './skeleton/src/index';

import {
    clearChooseCallerEpic,
} from './choosecaller/src/index';

import {
    fetchBillingDetailsFromEpic,
    pushBillingDetailsToState,
    pushSelectedBillingData,
    clearBillingEpic
} from './billing/src/index';

import {
    fetchInsuranceDetailsFromEpic,
    pushSelectedInsuranceData,
    clearInsuranceEpic,
    fetchFHIRDetailsFromEpic,
    clearFHIRInsuranceEpic
} from './insurance/src/index';


import {    
    fetchPrescriptionEpic, pushClearPrescription
} from './prescription/src/index';

import {
fetchMedicationEpic,
clearMedicationEpic
} from "./medication/src/index";

import {fetchMedicationinfoEpic} from "./medicationinfo/src/index";

import {
fetchOrdersRefEpic,
clearOrdersRefEpic
} from "./orders/src/index";

import {
fetchIdentifiersEpic,
clearIdentifierEpic
} from './patientidentifier/src/index'

import {
fetchEpicUserID
} from './getuserid/src/index';

import {
fetchUpdateUserID
} from './updateuserid/src/index';

import {
fetchServiceNowCallerEpic,
clearSNCallerDetailsEpic
} from './servicenow_callerdetails/src/index';

import {
fetchIncidentsEpic,
clearIncidentsEpic
} from './incidents/src/index';

import {
fetchInteractionsEpic,
clearInteractionsEpic
} from './interactions/src/index';

import {
fetchCreateInteractionsEpic
} from './create-interactions/src/index'

import {
fetchCreateIncidentsEpic
} from './create-incidents/src/index';

import {
fetchUpdateIncidentsEpic,
clearUpdateIncidentEpic
} from './update-incidents/src/index';

import {
fetchLinkedIncidentsEpic
} from './linkedincidents/src/index';

import {
    fetchPatientSearchInfo,
    clearPatientSearchEpic
} from "./btgpatientepic/src/index";

import {
    fetchSetSessionEpic, clearSetSessionEpic
} from './setssession-epic/src/index';

import {
    fetchGetSessionEpic, clearGetSessionEpic, clearSelectedSourceSessionEpic, clearSelectedSubSessionEpic
} from './getsession-epic/src/index';

import {
    fetchEndSessionEpic, clearEndSessionEpic
} from './endsession-epic/src/index';
import { 
    addNotesHistoryEpic, 
    clearNotesEpic, 
    fetchNotesHistoryEpic 
} from './notes-history/src';

import {
fetchBillingIdentifiersFromEpic
} from './billingidentifier/src/index';

import {
    fetchAccessIdentifierEpic
    } from './getaccessidentifier/src'; 

/**
 * This Function will add all the active epics
 * @param context contains setting json etc..
 */

const activeepics = (context: any) => {

    const { settings } = context;
    const { uisettings: { agent_notes,tabconfig, search,callingdestinationcard,btg_config, consolidated_api_invocation,dashboardapiconfig  } } = settings;


    /**
     * epicarray holds the active epics that will be executed
     * when ever an redux action is executed.
     */
    let epicarray: any = [];

    if(consolidated_api_invocation)
    {
        epicarray.push(fetchDashboardApi(context));
    }
    epicarray.push(fetchApptsEpic(context));
    epicarray.push(pushApptsTableEpic(context));
    epicarray.push(pushCancelApptToEpic(context));
    epicarray.push(pushConfirmApptToEpic(context));
    epicarray.push(pushUpdateApptToEpic(context));
    epicarray.push(clearAppointmentsEpic(context));
    epicarray.push(clearAppointmentsonPatientChangeEpic(context));
    epicarray.push(pushUpcomingApptsEpic(context));
    epicarray.push(clearUpcomingApptEpic(context));
    epicarray.push(pushPendingBillsToState(context));
    epicarray.push(fetchBillingIdentifiersFromEpic(context));
    epicarray.push(clearPendingBillsEpic(context));
    epicarray.push(skeletonUpcomingApptsReset(context));
    if(dashboardapiconfig?.getcallerdetails) {
        epicarray.push(fetchCallerDetailsFromDB(context));
    }
    epicarray.push(setSourceAsItIsSubject(context));
    epicarray.push(fetchEpicUserID(context));
    epicarray.push(fetchUpdateUserID(context));
    //commented 2 lines not to push patient caller data to source
    // epicarray.push(pushPatientDataToCaller(context));
    // epicarray.push(pushSelectedPatientDataToCaller(context));
    if(callingdestinationcard) {
        epicarray.push(fetchCallingDest(context));
        epicarray.push(clearCalledDestination(context));
    }
    epicarray.push(fetchSouceTypeToCaller(context));
    epicarray.push(fetchSelectedSouceTypeToCaller(context));
    epicarray.push(fetchPatientsEpic(context));
    epicarray.push(fetchPendingRefEpic(context));
    epicarray.push(clearPendingRefEpic(context));
    //epicarray.push(selectPatientsEpic(context));
    epicarray.push(selectDrawer(context));
    epicarray.push(healthAlert(context));
    if(consolidated_api_invocation)
    {
        epicarray.push(fetchConsolidatedAPIOneEpic(context));
    }
    if(dashboardapiconfig?.getpcprest) {
        epicarray.push(fetchPCPEpic(context));
        epicarray.push(clearPCPEpic(context));
    }


    //check for Pharmacy tab is enabled or not
    if(tabconfig.pharmacies) {
        epicarray.push(fetchPharmacyEpic(context));
        epicarray.push(clearPharmacyEpic(context));
    }
    epicarray.push(fetchScreenpopEpic(context));
    epicarray.push(fetchReceiveCommunicationEpic(context));
    epicarray.push(setCallerDetailsFromAddNew(context));
    epicarray.push(pushAddNewDataToCaller(context));
    epicarray.push(checkForAddNewNotification(context));
    epicarray.push(pushAddNewSelectedSouceTypeToCaller(context));
    epicarray.push(pushAddNewSelectedPatientDataToCaller(context));
    epicarray.push(fetchBillingDetailsFromEpic(context));
    epicarray.push(pushBillingDetailsToState(context));
    epicarray.push(pushSelectedBillingData(context));
    epicarray.push(clearBillingEpic(context));
    epicarray.push(fetchInsuranceDetailsFromEpic(context));
    epicarray.push(fetchFHIRDetailsFromEpic(context));
    epicarray.push(pushSelectedInsuranceData(context));
    epicarray.push(clearInsuranceEpic(context));
    epicarray.push(clearSourceEpic(context));
    epicarray.push(clearSourceTypeEpic(context));
    epicarray.push(clearErrorEpic(context));
    epicarray.push(clearSkeletonEpic(context));
    epicarray.push(clearChooseCallerEpic(context));
    epicarray.push(fetchIdentifiersEpic(context));
    epicarray.push(clearIdentifierEpic(context));
    epicarray.push(clearFHIRInsuranceEpic(context));
    epicarray.push(fetchAccessIdentifierEpic(context));
    // check for the patient global search is enbaled
    if (search.patient) {
        epicarray.push(fetchPatientsGlobalSearchEpic(context));
        epicarray.push(resetSpinForPateintGlobalSearchEpic(context));
    }
    // check for the provider global search is enbaled
    if (search.patient) {
        epicarray.push(fetchProvidersGlobalSearchEpic(context));
        epicarray.push(resetSpinForProviderGlobalSearchEpic(context));
    }
    // check for the traige tab enabled or not
    if (tabconfig.triage) {
        epicarray.push(fetchAllergiesEpic(context));
        epicarray.push(clearAllergiesEpic(context));
        epicarray.push(fetchActiveProblemEpic(context));
        epicarray.push(clearActiveProblemEpic(context));
        epicarray.push(fetchMedicalHistoryEpic(context));
        epicarray.push(clearMedicalHistoryEpic(context));
    }
    //check for Medication tab is enabled or not
    if(tabconfig.medication) {
        epicarray.push(fetchMedicationEpic(context));
        epicarray.push(clearMedicationEpic(context));
    }
    if(tabconfig.medicationinfo) {
        epicarray.push(fetchMedicationinfoEpic(context));
    }
    if(tabconfig.orders) {
        epicarray.push(fetchOrdersRefEpic(context));
        epicarray.push(clearOrdersRefEpic(context));
    }
    //check for prescription Prescription 
    if(tabconfig.prescription) {
        epicarray.push(fetchPrescriptionEpic(context));
        epicarray.push(pushClearPrescription(context));
    }

    //check for ServiceNow 
    if(tabconfig.servicenow) {
        epicarray.push(fetchServiceNowCallerEpic(context));
        epicarray.push(fetchCreateIncidentsEpic(context));
        epicarray.push(fetchLinkedIncidentsEpic(context));
        epicarray.push(fetchCreateInteractionsEpic(context));
        epicarray.push(fetchUpdateIncidentsEpic(context));
        //epicarray.push(clearSNCallerDetailsEpic(context));
        epicarray.push(clearUpdateIncidentEpic(context));
    }

    //Check for Incidents 
    if(tabconfig.incidents) {
        epicarray.push(fetchIncidentsEpic(context));
        epicarray.push(clearIncidentsEpic(context));
    }

    //Check for Interactions 
    if(tabconfig.interactions) {
        epicarray.push(fetchInteractionsEpic(context));
        epicarray.push(clearInteractionsEpic(context));
    }

    // Add pushCallDataRecord to Epic
    epicarray.push(pushCallRecord(context))

    // Add storeDispositionCode to Epic
    epicarray.push(storeDispositionCode(context))

    //Check is BTG feature is Enabled
    if (btg_config.btgenable) {
        epicarray.push(fetchPatientSearchInfo(context));
        epicarray.push(clearPatientSearchEpic(context));
    }
    //Adding Setsession Epic
    epicarray.push(fetchSetSessionEpic(context))
    epicarray.push(clearSetSessionEpic(context))

    //Adding Getsession Epic
    epicarray.push(fetchGetSessionEpic(context))
    //epicarray.push(clearGetSessionEpic(context))
    //epicarray.push(clearSelectedSubSessionEpic(context))
    //epicarray.push(clearSelectedSourceSessionEpic(context))

    epicarray.push(fetchEndSessionEpic(context))
    epicarray.push(clearEndSessionEpic(context))
     if (agent_notes.display) {
        epicarray.push(fetchNotesHistoryEpic(context));
        epicarray.push(addNotesHistoryEpic(context));
        epicarray.push(clearNotesEpic(context));
    }
    return epicarray;
}

/**
 * This Function will combine all active epics
 * @param context contains setting json etc..
 */
export const build = (context: any) => (
    combineEpics(
        ...activeepics(context),
    )
);